<template>
  <v-card class="d-flex flex-column fill-height">
    <v-toolbar color="primary" max-height="64">
      <v-toolbar-title class="mx-5 altfont" v-if="model && !isSmallScreen">{{ model.name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        @click="updateDrawerState"
        v-tooltip.bottom-center="drawer ? $t('cortona.ipc.hide-parts') : $t('cortona.ipc.show-parts')"
        class="d-print-none"
      ></v-app-bar-nav-icon>
      <v-btn
        v-if="isAdmin && !isResourcePublished"
        icon
        variant="plain"
        color="warning"
        v-tooltip.bottom-center="$t('cortona.ipc.resource-not-published', { status: model && model.status })"
        class="d-print-none"
      >
        <v-icon>mdi-alert-outline</v-icon>
      </v-btn>
      <v-btn icon @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text class="pa-0 flex-grow-1 d-flex flex-column">
      <div class="page-container-ins">
        <div class="player">
          <cortona-loader
            v-model="inin"
            :type="model.type"
            :modelPath="model.additionalParams.interactivityXml"
            ref="inin"
            @update="updateData"
            :key="model.id"
          />

          <v-toolbar class="controls" color="surface">
            <v-btn v-if="stepMode" @click="inin.previousStep()" icon size="small" color="primary" v-tooltip.top="$t('cortona.ins.previous-step')">
              <v-icon size="small">{{ ico.prev }}</v-icon>
            </v-btn>
            <v-btn
              @click="inin.switchPlaying()"
              icon
              size="large"
              color="primary"
              v-tooltip.top="playing ? $t('cortona.ins.pause') : $t('cortona.ins.play')"
            >
              <v-icon>{{ ico.play[playing] }}</v-icon>
            </v-btn>
            <v-btn
              v-if="stepMode"
              @click="inin.nextStep()"
              icon
              size="small"
              color="primary"
              v-tooltip.top="$t('cortona.ins.next-step')"
            >
              <v-icon size="small">{{ ico.next }}</v-icon>
            </v-btn>
            <div class="slider-wrapper">
              <v-slider
                class="slider"
                v-model="progress"
                :max="sliderMax"
                :step="1"
                hide-details
                :track-size="10"
                color="primary"
                track-color="secondary"
                track-fill-color="accent"
                @update:model-value="seekByProgress"
              ></v-slider>
              <div v-if="!stepMode" class="slider-marks-overlay" aria-hidden="true">
                <span
                  v-for="mark in sliderMarks"
                  :key="mark"
                  class="mark-dot"
                  :style="sliderMax > 0 ? { left: (mark / sliderMax * 100) + '%' } : {}"
                />
              </div>
            </div>
            <div class="time">{{ formattedTime }}</div>
            <v-btn
              v-if="stepMode"
              @click="inin.switchRepeat()"
              icon
              size="small"
              color="primary"
              v-tooltip.top="repeat ? $t('cortona.ins.repeat-disable') : $t('cortona.ins.repeat-enable')"
            >
              <v-icon size="small">{{ ico.loop[repeat] }}</v-icon>
            </v-btn>
            <v-btn
              @click="inin.switchStepMode()"
              icon
              size="small"
              color="primary"
              v-tooltip.top="stepMode ? $t('cortona.ins.show-all-steps') : $t('cortona.ins.show-one-step')"
            >
              <v-icon size="small">{{ ico.steps[stepMode] }}</v-icon>
            </v-btn>
          </v-toolbar>
        </div>

        <!--    @transitionend="$refs.inin.resizeFrame()"-->
        <div
          v-show="drawer"
          class="steps-drawer"
          :style="isLargeScreen ? { width: drawerWidth + 'px' } : {}"
        >
          <v-list>
            <v-list-item
              v-for="(step, index) in stepList"
              :key="step.id"
              :class="{ 'step-list-item': true, selected: currentStepId == step.id }"
              @click="inin.goToStep(step.id)"
            >
              <template #prepend>
                <span class="list-number">{{ index + 1 }}</span>
              </template>
              <v-list-item-title>{{ step.text }}</v-list-item-title>
              <v-list-item-subtitle v-if="step.warn" class="list-warning">{{ step.warn }}</v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import CortonaLoader from './CortonaLoader.vue';
import Intendation from '../basic/Intendation.vue'; // import Cart from '../cart/Cart.vue';
import LanguagePicker from '../basic/LanguagePicker.vue';
import { useAccountStore } from '@/stores/account';

export default {
  name: 'CortonaINS',
  components: {
    CortonaLoader: CortonaLoader,
    Intendation,
    // Cart,
    LanguagePicker,
  },
  props: {
    model: Object,
  },
  emits: ['closeDialog', 'reload'],
  data: () => ({
    inin: null,
    drawer: true,
    stepList: [],
    stepParts: null,
    step: 0.01,
    time: 0,
    playing: false,
    stepMode: true,
    repeat: false,
    marks: [],
    rangeStart: 0,
    rangeEnd: 0,
    currentStepNum: 0,
    currentStepId: null,
    numOfSteps: 0,
    ico: {
      prev: 'mdi-skip-previous',
      play: {
        true: 'mdi-pause',
        false: 'mdi-play',
      },
      next: 'mdi-skip-next',
      loop: {
        true: 'mdi-repeat-off',
        false: 'mdi-repeat',
      },
      steps: {
        true: 'mdi-ray-start-vertex-end',
        false: 'mdi-ray-start-end',
      },
    },
  }),
  watch: {
    ipcDrawer: {
      handler(current, prev) {
        // console.log('drawer changed value to', current);
      },
    },
  },
  methods: {
    updateDrawerState() {
      this.drawer = !this.drawer;
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    goHome() {
      this.$router.push({ name: 'root' });
    },
    updateData(name, value) {
      this[name] = value;
    },
    seekByProgress(progress) {
      let time = this.rangeStart + progress * this.step;
      this.inin.seekTime(time);
    },
    // async fetchStepList() {
    //     this.stepList = await api.getXml(this.model.additionalParams.interactivityXml)
    // },
  },
  // created() {
  //     this.fetchStepList();
  // },
  updated() {
    // this.$refs.inin.resizeFrame();
  },
  computed: {
    isAdmin() {
      const accountStore = useAccountStore();
      return accountStore.account?.userType === 'ADMIN';
    },
    isResourcePublished() {
      return !this.model || this.model.status === 'PUBLISHED';
    },
    isSmallScreen() {
      return this.$vuetify.display.width < 768;
    },
    isLargeScreen() {
      return this.$vuetify.display.width > 1264;
    },
    drawerWidth() {
      const screenWidth = this.$vuetify.display.width;
      return Math.round(screenWidth * 0.4);
    },
    tutorial() {
      return {
        nextStep: this.currentStepNum === 1 && this.time === this.rangeEnd,
      };
    },
    progress: {
      get() {
        return Math.floor((this.time - this.rangeStart) / this.step);
      },
      set(value) {
        this.seekByProgress(value);
      },
    },
    sliderMax() {
      return Math.ceil((this.rangeEnd - this.rangeStart) / this.step);
    },
    showRate() {
      if (this.time > this.rangeEnd && this.currentStepNum == this.numOfSteps) {
        this.inin.setShow();
        return true;
      }
      return false;
    },
    sliderMarks() {
      return this.marks.map(m => Math.floor((m - this.rangeStart) / this.step));
    },
    formattedTime() {
      let minutes = String(Math.floor(this.time / 60)).padStart(2, '0');
      let seconds = String(Math.floor(this.time % 60)).padStart(2, '0');
      return `${minutes}:${seconds}`;
    },
    stepInfo() {
      return `Krok ${this.currentStepNum} z ${this.numOfSteps}`;
    },
    currentStepItems() {
      // console.log("current step: ", this.currentStepId)
      return (this.stepParts && this.currentStepId && this.stepParts.find(s => s.id == this.currentStepId).parts) || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.player {
  display: flex;
  flex-direction: column;
  padding-bottom: 10px;
}

.slider-wrapper {
  position: relative;
  flex: 1;
  min-width: 0;
}

.slider {
  width: 100% !important;
}

.slider-marks-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
}

.mark-dot {
  position: absolute;
  top: 50%;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(var(--v-theme-primary));
  transform: translate(-50%, -50%);
}

.step-list-item {
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: rgb(var(--v-theme-secondary));
  }

  .list-number {
    display: flex;
    transition: background-color 0.3s ease-in-out;
    background-color: rgb(var(--v-theme-primary));
    color: white;
    font-size: large;
    font-weight: 500;
    margin-right: 1rem !important;
    align-self: center !important;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
  }

  .list-warning {
    color: rgb(var(--v-theme-error));
    margin-top: 3px;
  }

  &.selected {
    background-color: rgb(var(--v-theme-accent));
  }
}

.vue-slider-dot-handle {
  background: rgb(var(--v-theme-primary));
  width: 18px;
  height: 18px;
  margin: -1px 0 0 -1px;

  &::before {
    content: '';
    color: inherit;
    width: 40px;
    height: 40px;
    background: rgb(var(--v-theme-primary));
    opacity: 0.3;
    left: -12px;
    top: -12px;
    transform: scale(0);
    pointer-events: none;
    position: absolute;
    border-radius: 50%;
    z-index: -1;
    transition: transform 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  }

  &:hover::before {
    transform: scale(0.95);
  }

  &:active::before {
    transform: scale(1.2);
  }
}

html {
  overflow-y: auto;
  overflow-x: hidden;
}

.main {
  max-height: 100vh;
}

.page-container-ins {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  height: 100%;

  @media screen and (min-width: 1264px) {
    flex-direction: row;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 10px;
    z-index: 1;
    pointer-events: none;
    background: linear-gradient(to bottom,
      rgb(var(--v-theme-accent)) 0px,
      rgb(var(--v-theme-accent)) 5px,
      rgb(var(--v-theme-primary)) 5px,
      rgb(var(--v-theme-primary)) 10px
    );
  }
}

.player {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;

  @media screen and (max-width: 1263px) {
    flex: 0 0 60%;
  }
}

.steps-drawer {
  flex: 0 0 auto;
  overflow-y: auto;
  background-color: white;
  border-left: 1px solid #e0e0e0;

  @media screen and (max-width: 1263px) {
    flex: 1 1 40%;
    border-left: none;
    border-top: 1px solid #e0e0e0;
    width: 100% !important;
  }
}

.altfont {
  font-family: 'Saira Semi Condensed', sans-serif;
  font-size: 1.5rem !important;
}

.controls {
  overflow: visible !important;
}

.controls .v-toolbar__content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: stretch;
  // box-shadow: 0 -2px 2px 0 #0002;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  padding: 0px 2rem;
  overflow: visible !important;
}

.v-toolbar__content {
  gap: 1rem;
}

.header-bar {
  position: relative;
  filter: drop-shadow(0px 2px 3px #000a);
  @media screen {
    &::after {
      content: '';
      position: absolute;
      height: 2rem;
      background-color: rgb(var(--v-theme-primary));
      width: 100%;
      --cut: 2rem;
      clip-path: polygon(0 0, 100% 0%, 100% calc(100% - var(--cut)), 0% 100%);

      // top: 4rem;
      // left: 0;
      // border-right: 100vw solid transparent;
      // border-top: 2rem solid rgb(var(--v-theme-primary));
    }
  }
}

</style>
